import isNumber from 'lodash/isNumber';

const mt = math.create(math.all);

mt.config({
	number: 'BigNumber',
	precision: 64,
});

/**
 * 金额计算
 * @param {string} expression - 表达式，如：50 / 2
 * @returns {number}
 */
export const amountCalculate = expression => mt.number(mt.round(mt.evaluate(expression), 2));

/**
 * 分 => 元
 * @param fen
 * @returns {number}
 */
export const fen2yuan = fen => {
	let num = fen;
	if (!isNumber(fen)) {
		num = Number(fen);
	}
	return amountCalculate(`${num} / 100`);
};

/**
 * 元 => 分
 * @param {number} yuan - 金额：元
 * @returns {number}
 */
export const yuan2fen = yuan => amountCalculate(`${yuan} * 100`);

/**
 * 分 => 元，补零
 * @param {number} num - 分
 * @returns {string}
 */
export const fen2yuanAddZeroes = num => {
	const yuan = fen2yuan(num);
	return addZeroes(yuan);
};

/**
 * 补零
 * @param {number} num - 需要进行补零的原数字
 * @param {number} decimals - 需要补的最大位数
 * @returns {string}
 */
export const addZeroes = (num, decimals = 2) => {
	const dec = num.toString().split('.')[1];
	const len = dec && dec.length > decimals ? dec.length : decimals;
	return num.toFixed(len);
};
